import request from '../utils/request'

export function getBanner() {
    return request({
        url: '/index/banner',
        method: 'GET'
    })
}

export function getVideo() {
    return request({
        url: '/index/introduce',
        method: 'GET'
    })
}

export function getList(params) {
    return request({
        url: '/index/player',
        method: 'GET',
        params
    })
}

export function getModule() {
    return request({
        url: '/index/curriculum-module',
        method: 'GET'
    })
}

export function getProvince() {
    return request({
        url: '/index/province',
        method: 'GET'
    })
}